import type { PurchasableProduct } from '@repo/subscription/api';

export enum CreditModalType {
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS ',
}

export interface State {
  isInitialized: boolean;
  initializedForUserId: string | null;
  activeModal: CreditModalType | null;
  products: PurchasableProduct[];
  init: (
    userId?: string | null | false,
    userCountry?: string | null
  ) => Promise<void>;
  reset: () => void;
  getProducts: () => Promise<PurchasableProduct[]>;
  openModal: (modal: CreditModalType) => void;
  closeModal: () => void;
}

export type CreditSelector<T = State> = {
  [K in keyof Omit<T, 'initializedForUserId'>]: (state: T) => T[K];
};
